import { Injectable } from "@angular/core";
import { ImageGameLogEvent } from "src/app/interfaces/log/image-game-log";
import { LogService } from "../log.service";
import {
  ImageGameGuestDetailKakaoShareClickedParams,
  ImageGameGuestDetailLinkCopyClickedParams,
  ImageGameGuestDetailResultNextClickedParams,
  ImageGameGuestDetailResultPreviousClickedParams,
  ImageGameGuestDetailResultQuestionnaireViewedParams,
  ImageGameGuestDetailSeeResultClickedParams,
  ImageGameGuestDetailStartNewGameClickedParams,
  ImageGameGuestDetailViewedParams,
  ImageGameHostDetailKakaoShareClickedParams,
  ImageGameHostDetailLinkCopyClickedParams,
  ImageGameHostDetailResultNextClickedParams,
  ImageGameHostDetailResultPreviousClickedParams,
  ImageGameHostDetailResultQuestionnaireViewedParams,
  ImageGameHostDetailSeeResultClickedParams,
  ImageGameHostDetailStartNewGameClickedParams,
  ImageGameHostDetailViewedParams,
  ImageGameQuizCreateAnswerSelectClickedParams,
  ImageGameQuizCreateFinishNowClickedParams,
  ImageGameQuizCreateQuestionEditClickedParams,
  ImageGameQuizCreateQuestionEditSubmitParams,
  ImageGameQuizCreateQuestionnaireViewedParams,
  ImageGameQuizCreateQuizCreateSubmitParams,
  ImageGameQuizCreateUserAddedParams,
  ImageGameReplyCreateAnswerSelectClickedParams,
  ImageGameReplyCreateProfileSelectClickedParams,
  ImageGameReplyCreateQuestionnaireViewedParams,
  ImageGameReplyCreateReplyCreateSubmitParams,
  ImageGameReplyCreateSelectProfileViewedParams
} from "./image-game-log.params";

@Injectable({
  providedIn: 'root'
})
export class ImageGameLogService {
  constructor(private logService: LogService) {
    
  }

  logHomeImageGameImpression() {
    this.logService.eventLogging(ImageGameLogEvent.HOME_IMAGE_GAME_IMPRESSION)
  }
  logHomeImageGameClicked() {
    this.logService.eventLogging(ImageGameLogEvent.HOME_IMAGE_GAME_CLICKED)
  }
  logImageGameQuizCreateIntroViewed() {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_INTRO_VIEWED)
  }
  logImageGameQuizCreateNameEntryViewed() {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_NAME_ENTRY_VIEWED)
  }
  logImageGameQuizCreateMyNameEntered() {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_MY_NAME_ENTERED)
  }
  logImageGameQuizCreateUserAdded(params: ImageGameQuizCreateUserAddedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_USER_ADDED, params)
  }
  logImageGameQuizCreateQuestionnaireViewed(params: ImageGameQuizCreateQuestionnaireViewedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_QUESTIONNAIRE_VIEWED, params)
  }
  logImageGameQuizCreateAnswerSelectClicked(params: ImageGameQuizCreateAnswerSelectClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_ANSWER_SELECT_CLICKED, params)
  }
  logImageGameQuizCreateQuestionChangeClicked(params: ImageGameQuizCreateQuestionEditClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_QUESTION_CHANGE_CLICKED, params)
  }
  logImageGameQuizCreateQuestionEditClicked(params: ImageGameQuizCreateQuestionEditClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_QUESTION_EDIT_CLICKED, params)
  }
  logImageGameQuizCreateQuestionEditSubmit(params: ImageGameQuizCreateQuestionEditSubmitParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_QUESTION_EDIT_SUBMIT, params)
  }
  logImageGameQuizCreateQuizCreateSubmit(params: ImageGameQuizCreateQuizCreateSubmitParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_QUIZ_CREATE_SUBMIT, params)
  }
  logImageGameReplyCreateSelectProfileViewed(params: ImageGameReplyCreateSelectProfileViewedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_REPLY_CREATE_SELECT_PROFILE_VIEWED, params)
  }
  logImageGameReplyCreateProfileSelectClicked(params: ImageGameReplyCreateProfileSelectClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_REPLY_CREATE_PROFILE_SELECT_CLICKED, params)
  }
  logImageGameReplyCreateQuestionnaireViewed(params: ImageGameReplyCreateQuestionnaireViewedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_REPLY_CREATE_QUESTIONNAIRE_VIEWED, params)
  }
  logImageGameReplyCreateAnswerSelectClicked(params: ImageGameReplyCreateAnswerSelectClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_REPLY_CREATE_ANSWER_SELECT_CLICKED, params)
  }
  logImageGameReplyCreateReplyCreateSubmit(params: ImageGameReplyCreateReplyCreateSubmitParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_REPLY_CREATE_REPLY_CREATE_SUBMIT, params)
  }
  logImageGameHostDetailViewed(params: ImageGameHostDetailViewedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_VIEWED, params)
  }
  logImageGameHostDetailKakaoShareClicked(params: ImageGameHostDetailKakaoShareClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_KAKAO_SHARE_CLICKED, params)
  }
  logImageGameHostDetailLinkCopyClicked(params: ImageGameHostDetailLinkCopyClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_LINK_COPY_CLICKED, params)
  }
  logImageGameHostDetailSeeResultClicked(params: ImageGameHostDetailSeeResultClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_SEE_RESULT_CLICKED, params)
  }
  logImageGameHostDetailResultQuestionnaireViewed(params: ImageGameHostDetailResultQuestionnaireViewedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_RESULT_QUESTIONNAIRE_VIEWED, params)
  }
  logImageGameHostDetailResultNextClicked(params: ImageGameHostDetailResultNextClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_RESULT_NEXT_CLICKED, params)
  }
  logImageGameHostDetailResultPreviousClicked(params: ImageGameHostDetailResultPreviousClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_RESULT_PREVIOUS_CLICKED, params)
  }
  logImageGameHostDetailStartNewGameClicked(params: ImageGameHostDetailStartNewGameClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_HOST_DETAIL_START_NEW_GAME_CLICKED, params)
  }
  logImageGameGuestDetailViewed(params: ImageGameGuestDetailViewedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_VIEWED, params)
  }
  logImageGameGuestDetailKakaoShareClicked(params: ImageGameGuestDetailKakaoShareClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_KAKAO_SHARE_CLICKED, params)
  }
  logImageGameGuestDetailLinkCopyClicked(params: ImageGameGuestDetailLinkCopyClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_LINK_COPY_CLICKED, params)
  }
  logImageGameGuestDetailSeeResultClicked(params: ImageGameGuestDetailSeeResultClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_SEE_RESULT_CLICKED, params)
  }
  logImageGameGuestDetailResultQuestionnaireViewed(params: ImageGameGuestDetailResultQuestionnaireViewedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_RESULT_QUESTIONNAIRE_VIEWED, params)
  }
  logImageGameGuestDetailResultNextClicked(params: ImageGameGuestDetailResultNextClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_RESULT_NEXT_CLICKED, params)
  }
  logImageGameGuestDetailResultPreviousClicked(params: ImageGameGuestDetailResultPreviousClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_RESULT_PREVIOUS_CLICKED, params)
  }
  logImageGameGuestDetailStartNewGameClicked(params: ImageGameGuestDetailStartNewGameClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_GUEST_DETAIL_START_NEW_GAME_CLICKED, params)
  }
  logImageGameQuizCreateFinishNowClicked(params: ImageGameQuizCreateFinishNowClickedParams) {
    this.logService.eventLogging(ImageGameLogEvent.IMAGE_GAME_QUIZ_CREATE_FINISH_NOW_CLICKED, params)
  }
}